import './ResponsesImage.css';

import { cn } from '##/utils/bem';

export const cnResponsesImage = cn('ResponsesImage');
